"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const hooks_1 = require("../hooks");
const reactstrap_1 = require("reactstrap");
exports.ContentImportPanelToolbarContentSearchInput = () => {
    const { showSearch, searchQuery, contentItemsResult, } = hooks_1.useContentImportPanelData();
    const { setState } = hooks_1.useContentImportPanelUpdate();
    return (react_1.default.createElement(reactstrap_1.Input, { value: searchQuery, disabled: !showSearch, placeholder: contentItemsResult &&
            contentItemsResult.data &&
            contentItemsResult.data.contentItems
            ? `Search ${contentItemsResult.data.contentItems.length} content item${contentItemsResult.data.contentItems.length === 1 ? '' : 's'}...`
            : '', onChange: e => {
            setState({
                searchQuery: e.target.value,
            });
        } }));
};
//# sourceMappingURL=ContentSearchInput.js.map